import { BaseService } from '@/core/base-service';

export default class ChoreService extends BaseService<any> {
	public constructor() {
		super('services/servicezef/api/chore');
	}
}
